export default function (role) {
  switch (role) {
    case "ROOT":
      return [
        {
          title: "Home",
          to: "/main-menu",
          htmlBefore: '<i class="material-icons">home</i>',
          htmlAfter: "",
        }, 
        {
          title: "Metrics",
          to: "/dashboards",
          htmlBefore: '<i class="material-icons">insert_chart</i>',
          htmlAfter: "",
        },
        {
          title: "Management",
          htmlBefore: '<i class="material-icons">settings</i>',
          to: "/management",
        },
        {
          title: "Billing",
          htmlBefore: '<i class="material-icons">payment</i>',
          to: "/billing",
        },
        {
          title: "Accounts",
          htmlBefore: '<i class="material-icons">verified_user</i>',
          to: "/accounts",
        },
        {
          title: "Users",
          to: "/users",
          htmlBefore: '<i class="material-icons">account_circle</i>',
          htmlAfter: "",
        },
        {
          title: "Engines Types",
          htmlBefore: '<i class="material-icons">storage</i>',
          to: "/engines",
        }
      ];
    case "Admin":
      return [
        {
          title: "Home",
          to: "/main-menu",
          htmlBefore: '<i class="material-icons">home</i>',
          htmlAfter: "",
        },      
        {
          title: "Metrics",
          to: "/dashboards",
          htmlBefore: '<i class="material-icons">insert_chart</i>',
          htmlAfter: "",
        },
        {
          title: "Users",
          to: "/users",
          htmlBefore: '<i class="material-icons">account_circle</i>',
          htmlAfter: "",
        }
      ];
    case "Technical":
      return [
        {
          title: "Home",
          to: "/main-menu",
          htmlBefore: '<i class="material-icons">home</i>',
          htmlAfter: "",
        },
        {
          title: "Metrics",
          to: "/dashboards",
          htmlBefore: '<i class="material-icons">insert_chart</i>',
          htmlAfter: "",
        },
      ];
    case "Basic":
      return [
        {
          title: "Home",
          to: "/main-menu",
          htmlBefore: '<i class="material-icons">home</i>',
          htmlAfter: "",
        },      
        {
          title: "Metrics",
          to: "/dashboards",
          htmlBefore: '<i class="material-icons">insert_chart</i>',
          htmlAfter: "",
        }
      ];

    default:
      return [
        {
          title: "Engines Types",
          htmlBefore: '<i class="material-icons">storage</i>',
          to: "/engines",
        },
      ];
  }
}
